frappe.provide("frappe.ui");
frappe.provide("frappe.views");
frappe.provide("frappe.web_form_list");

import EventEmitterMixin from '../../../../../frappe/frappe/public/js/frappe/event_emitter';
import EventObserver from './EventObserver'

export default class WebFormList {
	constructor(opts) {
		Object.assign(this, opts);
		frappe.web_form_list = this;
		frappe.web_form_list.events = {};
        //Object.assign(frappe.web_form_list.event, EventEmitterMixin);
		this.create_events();

		this.wrapper = document.getElementById("datatable");
		this.webform_controller = opts.webform_controller;

		this.get_list_view_fields().then(()=>{
			this.refresh();
			this.make_actions();
			this.make_filters();
			$('.link-btn').remove();
		})
	}

	create_events() {
		this.events.setup = new EventObserver();
		this.events.after_load  = new EventObserver();
		this.events.row_added  = new EventObserver();
	}

	on(fieldname, handler) {
		switch (fieldname) {
			case 'setup':
				this.events.setup.subscribe(handler);
				break;
			case 'after_load':
				this.events.after_load.subscribe(handler);
				break;
			case 'row_added':
				this.events.row_added.subscribe(handler);
				break;
			default:
			let
				field = this.fields_list[fieldname];
				field.df.change = () => {
					handler(field, field.value);
				};
		}
    }

	refresh() {
		if (this.table) {
			Array.from(this.table.tBodies).forEach(tbody => tbody.remove());
			if (this.allow_select) {
				let check = document.getElementById('select-all')
				check.checked = false;
			}
		}
		this.rows = [];
		this.page_length = 20;
		this.web_list_start = 0;

		frappe.run_serially([
			() => this.events.setup.broadcast(this),
			() => this.get_data(),
			() => this.make_table(),
			() => this.create_more(),
			() => this.events.after_load.broadcast(this)
		]);
	}

	make_filters() {
		this.filters = {};
		this.filter_input = [];
		const filter_area = document.getElementById('list-filters');

		frappe.call(this.webform_controller + '.get_web_form_filters', {
			web_form_name: this.web_form_name
		}).then(response => {
			let fields = response.message;
			fields.forEach(field => {
				// let col = document.createElement('div');
				// //col.classList.add('form-group','frappe-control','input-max-width','col-md-2');
				// col.classList.add('col-md-2');
				// filter_area.appendChild(col);

				let input = frappe.ui.form.make_control({
					df: {
						fieldtype: field.fieldtype,
						fieldname: field.fieldname,
						options: field.options,
						only_select: true,
						label: __(field.label),
						onchange: (event) => {
							$('#more').remove();
							this.add_filter(field.fieldname, input.value, field.fieldtype);
							this.refresh();
						}
					},
					parent: filter_area,
					only_input: false,
					value: field.default,
					render_input: 1,
				});
				// $(input.wrapper).attr("title", __(field.label)).tooltip();
				this.filter_input.push(input)
			});
			$('.link-btn').remove();
		})
	}

	add_filter(field, value, fieldtype) {
		if (!value) {
			delete this.filters[field];
		} else {
			if (fieldtype === 'Data') value = ['like', value + '%'];
			Object.assign(this.filters, Object.fromEntries([[field, value]]));
		}
	}

	get_list_view_fields() {
		return frappe
			.call({
				method:
					this.webform_controller + ".get_in_list_view_fields",
				args: { web_form_name: this.web_form_name }
			})
			.then(response => (this.fields_list = response.message));
	}

	fetch_data() {
		if (this.webform_controller == 'frappe.website.doctype.web_form.web_form') {
			return frappe.call({
				method: "frappe.www.list.get_list_data",
				args: {
					doctype: this.doctype,
					fields: this.fields_list.map(df => df.fieldname),
					limit_start: this.web_list_start,
					web_form_name: this.web_form_name,
					...this.filters
				}
			});
		} else {
			return frappe.call({
				method: this.webform_controller + ".get_list_data",
				args: {
					doctype: this.doctype,
					fields: this.fields_list.map(df => df.fieldname),
					limit_start: this.web_list_start,
					web_form_name: this.web_form_name,
					filters: this.filters
				}
			});
		}
	}

	get_data() {
		return this.fetch_data().then((res) => {
			this.data = res.message;
		});
	}

	more() {
		this.web_list_start += this.page_length;
		this.fetch_data().then((res) => {
			if (res.message.length === 0) {
				frappe.msgprint(__("No more items to display"));
			}
			this.append_rows(res.message);
		});

	}

	make_table() {
		this.columns = this.fields_list.map(df => {
			return {
				label: df.label,
				fieldname: df.fieldname,
				fieldtype: df.fieldtype,
				options: df.options,
				click: new EventObserver()
			};
		});

		if (! this.table) {
			this.table = document.createElement("table");
			this.table.classList.add("table");
			this.make_table_head();
		}

		this.append_rows(this.data);

		this.wrapper.appendChild(this.table);
	}

	make_table_head() {
		// Create Heading
		let thead = this.table.createTHead();
		thead.style.backgroundColor = "#f7fafc";
		thead.style.color = "#8d99a6";
		let row = thead.insertRow();

		if (this.allow_select) {
			let th = document.createElement("th");

			let checkbox = document.createElement("input");
			checkbox.type = "checkbox";
			checkbox.id = "select-all";
			checkbox.onclick = event =>
				this.toggle_select_all(event.target.checked);

			th.appendChild(checkbox);
			row.appendChild(th);
		}

		add_heading(row, __("Sr"));
		this.columns.forEach(col => {
			add_heading(row, __(col.label));
		});

		function add_heading(row, label) {
			let th = document.createElement("th");
			th.innerText = label;
			row.appendChild(th);
		}
	}

	append_rows(row_data) {
		const tbody = this.table.childNodes[1] || this.table.createTBody();
		row_data.forEach((data_item) => {
			let row_element = tbody.insertRow();
			row_element.setAttribute("id", data_item.name);

			let row = new frappe.ui.WebFormListRow({
				row: row_element,
				doc: data_item,
				columns: this.columns,
				serial_number: this.rows.length + 1,
				events: {
					onEdit: () => this.open_form(data_item.name),
					onSelect: () => this.toggle_delete()
				},
				allow_select: this.allow_select
			});

			this.rows.push(row);
			this.events.row_added.broadcast(row);
		});
	}

	make_actions() {
		const actions = document.querySelector(".list-view-actions");

		frappe.has_permission(this.doctype, "", "delete", () => {
			this.addButton(actions, "delete-rows", "danger", true, "Delete", () =>
				this.delete_rows()
			);
		});

		this.addButton(
			actions,
			"new",
			"primary",
			false,
			"New",
			() => (window.location.href = window.location.pathname + "?new=1")
		);
	}

	addButton(wrapper, id, type, hidden, name, action) {
		if (document.getElementById(id)) return;
		const button = document.createElement("button");
		if (type == "secondary") {
			button.classList.add(
				"btn",
				"btn-secondary",
				"btn-sm",
				"ml-2",
				"text-white"
			);
		}
		else if (type == "danger") {
			button.classList.add(
				"btn",
				"btn-danger",
				"button-delete",
				"btn-sm",
				"ml-2"
			);
		}
		else {
			button.classList.add("btn", "btn-primary", "btn-sm", "ml-2");
		}

		button.id = id;
		button.innerText = name;
		button.hidden = hidden;

		button.onclick = action;
		wrapper.appendChild(button);
	}

	create_more() {
		if (this.rows.length >= this.page_length) {
			const footer = document.querySelector(".list-view-footer");
			this.addButton(footer, "more", "secondary", false, "More", () =>  this.more());
		}
	}

	toggle_select_all(checked) {
		this.rows.forEach(row => row.toggle_select(checked));
	}

	open_form(name) {
		window.location.href = window.location.pathname + "?name=" + name;
	}

	get_selected() {
		return this.rows.filter(row => row.is_selected());
	}

	toggle_delete() {
		if (!this.settings.allow_delete) return
		let btn = document.getElementById("delete-rows");
		btn.hidden = !this.get_selected().length;
	}

	delete_rows() {
		if (!this.settings.allow_delete) return
		frappe
			.call({
				type: "POST",
				method:
					this.webform_controller + ".delete_multiple",
				args: {
					web_form_name: this.web_form_name,
					docnames: this.get_selected().map(row => row.doc.name)
				}
			})
			.then(() => {
				this.refresh()
				this.toggle_delete()
			});
	}
};

frappe.ui.WebFormListRow = class WebFormListRow {
	constructor({ row, doc, columns, serial_number, events, allow_select, options }) {
		Object.assign(this, { row, doc, columns, serial_number, events, allow_select });
		this.make_row();
	}

	make_row() {
		if (this.allow_select) {
			// Add Checkboxes
			let cell = this.row.insertCell();

			this.checkbox = document.createElement("input");
			this.checkbox.type = "checkbox";
			this.checkbox.onclick = event => {
				this.toggle_select(event.target.checked);
				event.stopImmediatePropagation();
			}

			cell.appendChild(this.checkbox);
		}

		// Add Serial Number
		let serialNo = this.row.insertCell();
		serialNo.innerText = this.serial_number;

		var me = this;

		this.columns.forEach(field => {
			let cell = this.row.insertCell();
			let formatter = frappe.form.get_formatter(field.fieldtype);
			if (field.fieldtype == "Button") {
				var $input = $('<button class="btn btn-primary btn-xs">')
					.prependTo(cell)
					.data('name',this.doc.name)
					.on("click", function () {field.click.broadcast(me);})
					.html((field.icon ? ('<i class="' + field.icon+' fa-fw"></i> ') : "") + __(this.doc[field.fieldname]));
			} else {
				cell.innerHTML = this.doc[field.fieldname] &&
					__(formatter(this.doc[field.fieldname], field, {only_value: 1}, this.doc)) || "";
			}
		});

		this.row.onclick = () => this.events.onEdit();
		this.row.style.cursor = "pointer";
	}

	toggle_select(checked) {
		if (!this.checkbox.prop("disabled")) {
			this.checkbox.checked = checked;
			this.events.onSelect.broadcast(this);
		}
	}

	is_selected() {
		return this.checkbox.checked;
	}
};
